import { KudosType } from '../types'

/**
 * Maps a KudosType to the corresponding Ant Design icon name
 * @param type - The KudosType to map
 * @returns 'like' for Positive kudos, 'dislike' for Negative kudos
 */
export const getKudosIcon = (type: KudosType): 'clap_fill' | 'siren_fill' => {
  return type === KudosType.Positive ? 'clap_fill' : 'siren_fill'
}

/**
 * Maps a KudosType to the corresponding icon color
 * @param type - The KudosType to map
 * @returns 'success' for Positive kudos, 'error' for Negative kudos
 */
export const getKudosColor = (type: KudosType): 'success' | 'error' => {
  return type === KudosType.Positive ? 'success' : 'error'
}
